import { Link } from "@inertiajs/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import ContentLayout from "../shared/ContentLayout";
import PageHeader from "../shared/PageHeader";
import RichMarkdownContent from "../Announcements/RichMarkdownContent";

interface Reference {
  id: number;
  title: string;
  content: string | null;
  image_url: string | null;
}

interface Section {
  id: number;
  title: string;
}

interface ReferenceInfo {
  id: number;
  title: string;
  path: string;
}

export default function ReferenceShow({
  section,
  reference,
  nextReference,
  previousReference,
}: {
  section: Section;
  reference: Reference;
  nextReference: ReferenceInfo | null;
  previousReference: ReferenceInfo | null;
}) {
  const renderBreadcrumbs = () => (
    <div className="flex justify-between items-center">
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link href="/" className="link link-primary">
              Home
            </Link>
          </li>
          <li>
            <Link href="/references" className="link link-primary">
              References
            </Link>
          </li>
          <li>
            <Link href={`/references/${section.id}`} className="link link-primary">
              {section.title}
            </Link>
          </li>
          <li>
            <span>{reference.title}</span>
          </li>
        </ul>
      </div>

      <div className="flex gap-2">
        {previousReference && (
          <Link
            href={previousReference.path}
            className="btn btn-outline btn-primary btn-xs"
            title={previousReference.title}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </Link>
        )}
        {nextReference && (
          <Link
            href={nextReference.path}
            className="btn btn-outline btn-primary btn-xs"
            title={nextReference.title}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        )}
      </div>
    </div>
  );

  const renderFooterNavigation = () => (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        {previousReference && (
          <Link
            href={previousReference.path}
            className="btn btn-sm btn-outline btn-primary w-full justify-start"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
            <span className="truncate">{previousReference.title}</span>
          </Link>
        )}
      </div>

      <div className="flex items-center justify-center">
        <Link href={`/references/${section.id}`} className="btn btn-primary btn-sm">
          All in {section.title}
        </Link>
      </div>

      <div>
        {nextReference && (
          <Link
            href={nextReference.path}
            className="btn btn-sm btn-outline btn-primary w-full justify-end"
          >
            <span className="truncate">{nextReference.title}</span>
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        )}
      </div>
    </div>
  );

  return (
    <ContentLayout
      breadcrumbs={renderBreadcrumbs()}
      footerNavigation={renderFooterNavigation()}
    >
      <div className="p-3 sm:p-4 max-w-4xl">
        <PageHeader title={reference.title} />
        <div className="prose prose-lg max-w-none" style={{ lineHeight: '1.75' }}>
          <RichMarkdownContent>
            {reference.content || ''}
          </RichMarkdownContent>
        </div>
      </div>
    </ContentLayout>
  );
}
